import { render, staticRenderFns } from "./FormNew.vue?vue&type=template&id=653b1872&"
import script from "./FormNew.vue?vue&type=script&lang=js&"
export * from "./FormNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports